const getters = {
  getCommercialLines: (state) => state.commercialLines,
  getCommercialLinesMeta: (state) => state.commercialLinesMeta,
  getQuickViews: (state) => state.quickViews,
  getCommercialLine: (state) => state.commercialLine,
  getListProductCategory: (state) => state.listProductCategory,
};

export default getters;
